/*export const templateUrlConfigMtr = {
  mtrwb: './mtrwb-edit/mtrwb-editPkg.component.html',
  mtrwc: './mtrwc-editPkg.component.html',
  mtrwd: './mtrwd-edit.component.html',
  mtrwf: './mtrwf-editPkg.component.html',
  mtrwl: './mtrwl-edit.component.html',
  mtrki01: './mtrki01Pkg.component.html',
  mtrki01_detail: './mtrki01-detailPkg.component.html',
  mtrki02: './mtrki02.component.html',
  mtrki02_detail: './mtrki02-detailPkg.component.html',
  mtrpi01: './mtrpi01Pkg.component.html',
  mtrpi01_detail: './mtrpi01-detailPkg.component.html',
};*/

export * from './services/mtrmb.service';
export * from './services/mtrwb.service';
export * from './services/mtrwc.service';
export * from './services/mtrwf.service';
export * from './services/mtrwl.service';
export * from './services/mtrwd.service';
export * from './services/mtrwf.service';
export * from './services/mtrwl.service';
